export default function EditorialMarquee() {
  const logos = [
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/profit.png",
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/vic.png",
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/ticccc.png",
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/bestjob.png",
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/see.png",
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/personagrow.png",
    "https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2026/08/data-.png",
  ];

  return (
    <section className="pt-16 pb-10 border-y border-zinc-900 overflow-hidden bg-brand-bg">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">

        <p className="text-center text-xs uppercase tracking-[0.35em] text-brand-mint mb-12">
          Brands we've helped grow
        </p>

        <div className="relative overflow-hidden">

          <div className="flex gap-28 whitespace-nowrap animate-marquee">

            {[...logos, ...logos].map((logo, i) => (
              <div
                key={i}
                className="flex items-center justify-center shrink-0"
              >
                <img
                  src={logo}
                  alt=""
                  className="h-[170px] w-auto opacity-80 brightness-150 grayscale transition-all duration-500 hover:opacity-100 hover:grayscale-0" 
                />
              </div>
            ))}

          </div>

          <div className="absolute left-0 top-0 h-full w-40 bg-gradient-to-r from-brand-bg to-transparent pointer-events-none" />
          <div className="absolute right-0 top-0 h-full w-40 bg-gradient-to-l from-brand-bg to-transparent pointer-events-none" />

        </div>
      </div>
    </section>
  );
}